import { apiFetch } from '@nrdy-marketing-engine/api-fetch';

async function createLearner(body, clientID: string): Promise<any> {
  try {
    if (!clientID || !body) return null;
    return await apiFetch(`/vtwa/v5/clients/${clientID}/students`, {
      body: JSON.stringify({ ...body }),
      method: 'POST',
    });
  } catch (e) {
    return null;
  }
}
export { createLearner };
